<template>
    <div :style="{height: content.height + 'px'}" v-if="content" class="spacer">

    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
            default: null
        }
    }
}
</script>

<style lang="scss">
</style>
